// Landing section on card payments: how a card payment reaches the merchant
// and what the merchant should know about it.

const STEPS = [
  {
    title: "Customer taps “Pay by card”",
    desc: "Right on your checkout, next to the crypto options. No wallet or exchange account needed.",
  },
  {
    title: "Stripe charges the card",
    desc: "Our partner Stripe processes the card and buys the exact invoice amount in USDC.",
  },
  {
    title: "You get USDC",
    desc: "It arrives on your invoice like any other crypto payment: same balance, same webhook.",
  },
];

const FACTS = [
  {
    title: "No chargebacks on your balance",
    desc: "Stripe is the merchant of record for the card payment and handles fraud and disputes.",
    icon: "M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6l7-3zM8.5 12l2.5 2.5 4.5-5",
  },
  {
    title: "The full amount",
    desc: "Card and network fees are paid by the customer on top of the invoice.",
    icon: "M12 3v18M16.5 7.5c-.8-1.2-2.5-2-4.5-2-2.5 0-4.5 1.3-4.5 3.2 0 4.3 9 2.3 9 6.6 0 1.9-2 3.2-4.5 3.2-2 0-3.7-.8-4.5-2",
  },
  {
    title: "US and EU customers",
    desc: "Card payments work for payers in the US and the EU. Everyone else pays in crypto.",
    icon: "M12 21a9 9 0 100-18 9 9 0 000 18zM3 12h18M12 3c2.5 2.5 3.5 5.5 3.5 9s-1 6.5-3.5 9c-2.5-2.5-3.5-5.5-3.5-9s1-6.5 3.5-9z",
  },
];

const CARD = "backdrop-blur-[17.5px] bg-[rgba(4,4,4,0.35)] border border-[#111] rounded-2xl p-6";

export default function CardPayments() {
  return (
    <section className="mb-20 md:mb-40 lg:mb-52" id="card">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="flex flex-col md:flex-row items-start justify-between gap-8 mb-14 scroll">
          <h2 className="text-white text-3xl md:text-4xl lg:text-[48px] font-medium leading-[1.05] max-w-[670px]">
            Customers without crypto can pay by card
          </h2>
          <p className="text-white/50 text-base leading-[1.5] max-w-[450px]">
            The “Pay by card” button shows up on your checkout by itself, on every invoice that
            accepts USDC. No new integration and nothing to switch on.
          </p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-4 mb-4 scroll">
          <div className="absolute -top-10 left-1/4 w-[618px] h-[300px] rounded-full bg-[rgba(0,121,236,0.1)] blur-[160px] -z-10" />
          {STEPS.map((s, i) => (
            <div key={s.title} className={`${CARD} flex flex-col gap-4`}>
              <span className="w-9 h-9 rounded-full border border-[#0079ec]/60 text-[#77BDFF] text-sm font-medium flex items-center justify-center">
                {i + 1}
              </span>
              <h3 className="text-white text-lg font-medium">{s.title}</h3>
              <p className="text-white/45 text-sm leading-normal">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 scroll">
          {FACTS.map((f) => (
            <div key={f.title} className={`${CARD} flex gap-4`}>
              <svg className="w-6 h-6 shrink-0 text-[#77BDFF]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d={f.icon} />
              </svg>
              <div className="flex flex-col gap-1.5">
                <h3 className="text-white text-base font-medium">{f.title}</h3>
                <p className="text-white/45 text-sm leading-normal">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
